var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.222,
    height: 25.985,
    viewBox: "0 0 16.222 25.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12509",
    "data-name": "Group 12509",
    transform: "translate(714.071 -847.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38489",
    "data-name": "Path 38489",
    d: "M52.879,965.7l-.989-.8c.29,0,.464-.008.637,0a16.559,16.559,0,0,0,3.781-.425,4.8,4.8,0,0,1,3.678.921,1.3,1.3,0,0,1,.565.9.455.455,0,0,0,.205.266,2.151,2.151,0,0,1,1,1.88,15.953,15.953,0,0,1-.1,1.632c-.015.18-.038.306.163.448a.84.84,0,0,1,.3.616,4.826,4.826,0,0,1-.952,3.064,1.493,1.493,0,0,0-.2.528,7.182,7.182,0,0,1-2.018,3.556,3.574,3.574,0,0,1-4.788.057,7,7,0,0,1-2.069-3.567,2.727,2.727,0,0,0-.379-.8,4.878,4.878,0,0,1-.779-2.937.707.707,0,0,1,.278-.515c.228-.136.177-.277.172-.473a11.813,11.813,0,0,1,.013-2.1,2.849,2.849,0,0,1,1.485-2.264m-.347,5.38c-.118-.058-.223-.115-.334-.163-.535-.23-.866-.031-.864.552a3.908,3.908,0,0,0,.117,1.007c.153.555.281,1.149.948,1.367.058.019.073.186.1.287a14.678,14.678,0,0,0,.6,2.2,3.641,3.641,0,0,0,6.538.573,6.094,6.094,0,0,0,.825-2.311c.072-.362.027-.766.515-.936a.836.836,0,0,0,.37-.517,11.5,11.5,0,0,0,.354-1.474.685.685,0,0,0-.255-.783c-.281-.159-.537-.01-.772.157-.016.011-.045,0-.087.007-.042-.294-.073-.592-.128-.886a1.979,1.979,0,0,0-2.271-1.893,1.949,1.949,0,0,1-.254,0,.591.591,0,0,1-.269-.078,3.177,3.177,0,0,0-3.949.073,2.232,2.232,0,0,0-.984,1.434c-.094.449-.136.909-.2,1.387",
    transform: "translate(-765 -105.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38490",
    "data-name": "Path 38490",
    d: "M53.287,965.339v-8.72h3.184",
    transform: "translate(-765 -105.962)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38491",
    "data-name": "Path 38491",
    d: "M63.63,956.619h3.021V973.8H61.306",
    transform: "translate(-765 -105.962)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38492",
    "data-name": "Path 38492",
    d: "M61.721,955h0a1.244,1.244,0,0,0-1.245-1.245h-.851A1.244,1.244,0,0,0,58.38,955a.664.664,0,0,1-.664.664H56.471v1.909H63.63v-1.909H62.385A.664.664,0,0,1,61.721,955Z",
    transform: "translate(-765 -105.962)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 5.575,
    transform: "translate(-705.558 853.343)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x2: 5.566,
    transform: "translate(-705.548 855.285)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x2: 5.565,
    transform: "translate(-705.548 857.228)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x2: 3.794,
    transform: "translate(-703.776 859.17)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x2: 2.591,
    transform: "translate(-702.573 861.112)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5516",
    "data-name": "Rectangle 5516",
    width: 3.244,
    height: 3.707,
    transform: "translate(-710.182 853.353)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon13);
export default __webpack_public_path__ + "static/media/sidebar-icon-13.f459e1234de63ef1c799ef478f1d41e6.svg";
export { ForwardRef as ReactComponent };